<script>
	import { Tooltip } from "bits-ui";
  import { cn } from '@lib/utils'

  let { hint, children, delay = 200, class: className, strategy = 'fixed' } = $props()
  
</script>
 
{#if hint}

  <Tooltip.Provider delayDuration={delay} ignoreNonKeyboardFocus>
    <Tooltip.Root class="contents">
      <Tooltip.Trigger>
        {@render children?.()}
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <!-- z-[9999] puts the tooltip above modals (.modal-bg at 9998). -->
        <Tooltip.Content {strategy} class="z-[9999]">
          <Tooltip.Arrow />
          <div class={cn("text-[11px] bg-black text-white rounded-sm px-2 py-1", className)}>
            {hint}
          </div>
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>

{:else}
  {@render children?.()}
{/if}